// src/jira/dashboard/types.ts
var JiraDashboardAriResourceOwner = "jira", JiraDashboardAriResourceType = "dashboard";

export {
  JiraDashboardAriResourceOwner,
  JiraDashboardAriResourceType
};
